export default __webpack_public_path__ + "static/media/grafema_martini-contest_08.ea6443ac.jpg";